import Modal from "./modal.js";
import { $_GET, trans } from "../globalFunctions.js";

export default class TransactionModal extends Modal {
  constructor(modalId, companyId) {
    super(modalId);
    this.companyId = companyId;
    this.stakeholders = [];
    this.documentsPromise = this.setupDocuments();
    this.setupNumericFields();
    this.detectFutureDates();

    // Setup listeners
    document.querySelectorAll("[data-btn-add-bulk]").forEach((el) => {
      el.addEventListener("click", () => {
        this.openReactBulkModal(el.getAttribute("data-btn-add-bulk"));
      });
    });
  }

  detectFutureDates() {
    const date = this.$form.querySelector('[name="date"]');

    date?.addEventListener("change", () => {
      if (
        date.valueAsDate > new Date() &&
        typeof window.pequeData.simulation === "undefined" &&
        $_GET("simulation") === null
      ) {
        const $container = this.$form.querySelector(
          "[data-bs-target=\"[data-container='documents']\"]"
        );

        if (!$container) {
          return;
        }
        let alert = this.$form.querySelector(
          '[data-id="future-transaction-alert"]'
        );

        if (!alert) {
          alert = document.createElement("div");
          alert.classList.add("row");
          alert.dataset.id = "future-transaction-alert";
          alert.innerHTML =
            `<div class="alert alert-primary text-white">
                                <div class="row">
                                  <div class="col-10">
                                      ` +
            trans("dont_add_future_events_in_transactions") +
            `
                                  </div>
                                  <div class="col-2 my-auto">
                                        <button type="button" class="btn btn-info mb-0 w-100 my-auto"><i class="fas fa-play"></i></button>
                                  </div>
                                </div>
                            </div>`;
          alert.querySelector("button").addEventListener("click", () => {
            peque.showTutorialModal(
              "https://www.youtube.com/embed/hhoco9IrSvM"
            );
          });
          $container.parentElement.insertBefore(alert, $container);
        }

        alert.classList.remove("d-none");
      } else {
        const alert = this.$form.querySelector(
          '[data-id="future-transaction-alert"]'
        );

        if (alert) {
          alert.classList.add("d-none");
        }
      }
    });
  }

  setupStakeholders() {
    return new Promise((resolve, reject) => {
      this.getStakeholders().then((stakeholders) => {
        const $stakeholderSelect = this.$form.querySelector(
          '[name="stakeholder"]'
        );
        const $beneficiarySelect = this.$form.querySelector(
          '[name="beneficiary"]'
        );

        this.setupStakeholderSelectors(
          stakeholders,
          $stakeholderSelect,
          $beneficiarySelect,
          resolve
        );
      });
    });
  }

  setupStakeholderSelectors(
    stakeholders,
    $stakeholderSelect,
    $beneficiarySelect,
    resolve
  ) {
    stakeholders.forEach((entry) => {
      const el = document.createElement("option");
      el.innerText =
        typeof entry.fullName !== "undefined" ? entry.fullName : entry.name;
      el.value = entry.id;
      el.dataset.type = entry.type;
      $stakeholderSelect.appendChild(el);

      if ($beneficiarySelect != null) {
        const el2 = document.createElement("option");
        el2.innerText =
          typeof entry.fullName !== "undefined" ? entry.fullName : entry.name;
        el2.value = entry.id;
        $beneficiarySelect.appendChild(el2);
      }
    });

    $stakeholderSelect.addEventListener("change", () => {
      const type = parseInt(
        $stakeholderSelect.querySelector(
          'option[value="' + $stakeholderSelect.value + '"]'
        ).dataset.type
      );
      let $beneficiaryContainer = $beneficiarySelect.closest(".col-12");

      if ($beneficiaryContainer == null) {
        $beneficiaryContainer = $beneficiarySelect.parentElement.parentElement;
      }

      if (type === peque.STAKEHOLDER_TYPE_ENTITY) {
        $beneficiaryContainer.classList.remove("d-none");
      } else {
        $beneficiaryContainer.classList.add("d-none");
      }
    });

    const autocompleteOptions = {
      inputClasses: ["form-control"],
      dropdownClasses: ["border"],
      allowHTML: true,
      customFilter: (results, instance) => {
        let hasCreateOption = false;

        results.forEach((entry, i) => {
          if (entry.value === "create-stakeholder") {
            hasCreateOption = true;
          }
        });

        if (!hasCreateOption && instance.createOption) {
          results.push(instance.createOption);
        }

        return results;
      },
    };
    const stakeholderAutocomplete = new AutocompleteSelect(
      $stakeholderSelect,
      autocompleteOptions
    );

    this.addCreateStakeholder(stakeholderAutocomplete);

    if ($beneficiarySelect != null) {
      const beneficiaryAutocomplete = new AutocompleteSelect(
        $beneficiarySelect,
        autocompleteOptions
      );
      this.addCreateStakeholder(beneficiaryAutocomplete);
    }

    resolve(stakeholders);
  }

  addCreateStakeholder(autocomplete) {
    autocomplete.add(
      '<i class="fas fa-plus"></i> ' + trans("add_stakeholder"),
      "create-stakeholder",
      false
    );
    autocomplete.createType = "stakeholder";
    autocomplete.createOption =
      autocomplete.originalOptions[autocomplete.originalOptions.length - 1];

    autocomplete.$select.addEventListener("change", () => {
      if (autocomplete.$select.value !== "create-stakeholder") {
        return;
      }
      if (typeof peque.stakeholderModal === "undefined") {
        peque.stakeholderModal = new StakeholderModal();
      }

      peque.stakeholderModal.setCallback((response) => {
        const autocompleteId = autocomplete.getId();

        // the new stakeholder to all existing stakeholder selects
        this.addOptionToAllSelects(response, "stakeholder", autocompleteId);

        // trigger change event to see if beneficiary field should be shown
        if (autocomplete.$select.name.includes("stakeholder")) {
          autocomplete.$select.dispatchEvent(new Event("change"));
        }
        document.body.dispatchEvent(
          new CustomEvent("new-stakeholder", {
            detail: response,
          })
        );

        peque.stakeholderModal.hide();
      });
      peque.stakeholderModal.show();
    });
  }

  addOptionToAllSelects(response, selectType, autocompleteId) {
    Object.keys(window.autocompleteInstances).forEach((id) => {
      const instance = window.autocompleteInstances[id];

      if (
        typeof instance.createType === "undefined" ||
        instance.createType !== selectType
      ) {
        return;
      }

      const $option = instance.add(
        response.name,
        response.id,
        id === autocompleteId
      );
      if (typeof response.type !== "undefined") {
        $option.dataset.type = response.type;
      }

      // move create option at the bottom
      instance.originalOptions.push(
        instance.originalOptions.splice(
          instance.originalOptions.indexOf(instance.createOption),
          1
        )[0]
      );
      instance.resetContainer();
    });
  }

  getStakeholders() {
    return new Promise((resolve, reject) => {
      peque
        .api("stakeholders", { company: this.companyId }, "get")
        .then((response) => {
          if (response.error > 0) {
            reject();
            return;
          }

          response.result.list.forEach((stakeholder) => {
            this.stakeholders.push({
              id: stakeholder.id,
              type: stakeholder.type,
              name: stakeholder.fullName,
              group: stakeholder.group,
              email: stakeholder.email,
            });
          });
          resolve(this.stakeholders);
        });
    });
  }

  setupShareClasses() {
    return new Promise((resolve, reject) => {
      const $container = this.$form.querySelector('[name="share-class"]');

      peque
        .api("shareclasses", { company: this.companyId }, "get")
        .then((response) => {
          const list = {};
          response.result.list.forEach((shareClass) => {
            list[shareClass.id] = shareClass;
            const el = document.createElement("option");
            el.innerText = shareClass.name;
            el.value = shareClass.id;
            $container.appendChild(el);
          });
          this.$shareClassAutocomplete = new AutocompleteSelect($container, {
            inputClasses: ["form-control"],
            dropdownClasses: ["border"],
            allowHTML: true,
          });

          // add share class option
          this.$shareClassAutocomplete.add(
            '<i class="fas fa-plus"></i> ' + trans("add_share_class"),
            "create-share-class",
            false
          );
          this.$shareClassAutocomplete.createType = "shareclass";
          this.$shareClassAutocomplete.createOption =
            this.$shareClassAutocomplete.originalOptions[
              this.$shareClassAutocomplete.originalOptions.length - 1
            ];

          this.$shareClassAutocomplete.$select.addEventListener(
            "change",
            () => {
              if (
                this.$shareClassAutocomplete.$select.value !==
                "create-share-class"
              ) {
                return;
              }
              if (typeof peque.shareClassModal === "undefined") {
                peque.shareClassModal = new ShareClassModal();
              }

              peque.shareClassModal.setCallback((response) => {
                this.addOptionToAllSelects(
                  response,
                  "shareclass",
                  this.$shareClassAutocomplete.getId()
                );
              });
              peque.shareClassModal.show();
            }
          );

          resolve(list);
        });
    });
  }

  setupPools() {
    return new Promise((resolve, reject) => {
      const $container = this.$form.querySelector('[name="pool"]');

      peque
        .api(
          "pools",
          {
            company: this.companyId,
            simulation:
              typeof window.pequeData.simulation === "undefined"
                ? $_GET("simulation")
                : window.pequeData.simulation,
          },
          "get"
        )
        .then((response) => {
          response.result.list.forEach((shareClass) => {
            const el = document.createElement("option");
            el.innerText = shareClass.name;
            el.value = shareClass.id;
            $container.appendChild(el);
          });
          new AutocompleteSelect($container, {
            inputClasses: ["form-control"],
            dropdownClasses: ["border"],
          });
          resolve(response.result.list);
        });
    });
  }

  getDocuments() {
    return new Promise((resolve, reject) => {
      peque
        .api("documents", { company: this.companyId }, "get")
        .then((response) => {
          if (response.error > 0) {
            return;
          }

          const list = [];

          response.result.list.forEach((doc) => {
            list.push({
              id: doc.id,
              link: doc.link,
              name: doc.name + "." + doc.extension,
            });
          });
          resolve(list);
        });
    });
  }

  setupDocuments() {
    this.$documentSelector = this.$form.querySelector(
      '[data-container="documents"] select'
    );

    if (this.$documentSelector == null) {
      return;
    }

    this.$form
      .querySelector('[data-action="upload-document"]')
      .addEventListener("click", () => {
        if (typeof peque.uploadDocumentModal === "undefined") {
          peque.uploadDocumentModal = new UploadDocumentModal(this.companyId);
        }
        const modal = peque.uploadDocumentModal;
        modal.setCallback((document) => {
          const $option = this.$documentsAutocomplete.add(
            document.name,
            document.id
          );
          $option.dataset.link = document.link;

          this.$documentsAutocomplete.select(document.id);
        });
        modal.show();
      });

    return this.getDocuments().then((list) => {
      list.forEach((doc) => {
        const el = document.createElement("option");
        el.innerText = doc.name;
        el.value = doc.id;
        el.dataset.link = doc.link;
        this.$documentSelector.appendChild(el);
      });

      this.$documentsAutocomplete = this.setupDocumentSelector(
        this.$documentSelector,
        this.$form.querySelector('[data-container="documents"]')
      );
    });
  }

  setupDocumentSelector($documentSelector, $container) {
    const $documentsAutocomplete = new AutocompleteSelect($documentSelector, {
      inputClasses: ["form-control"],
      dropdownClasses: ["border"],
    });

    $documentSelector.addEventListener("change", () => {
      const documentId = parseInt($documentSelector.value);

      if (documentId < 1) {
        return;
      }

      this.addDocument(documentId, null, $documentSelector, $container);
      $documentSelector.value = ""; // reset it to select position
    });

    return $documentsAutocomplete;
  }

  addDocument(documentId, doc, $documentSelector, $container) {
    // document already added
    if (
      $container.querySelector('[data-document-id="' + documentId + '"]') !=
      null
    ) {
      // document id got lost because of form reset
      const $input = $container.querySelector(
        '[data-document-id="' + documentId + '"] input'
      );
      if ($input.value.length < 1) {
        $input.value = documentId;
      }
      return;
    }
    const option = $documentSelector.querySelector(
      'option[value="' + documentId + '"]'
    );

    if (option === null) {
      return;
    }

    const template = peque.parseTemplate("document", {
      id: documentId,
      name: doc ? doc.name : option.innerText,
      link: doc ? doc.link : option.dataset.link,
    });

    template.querySelector("button").addEventListener("click", () => {
      template.remove();
    });

    $container.prepend(template);
  }

  clearDocuments() {
    this.$form.querySelectorAll("[data-document-id]").forEach((el) => {
      el.remove();
    });
    return this;
  }

  getLatestNumeration() {
    return new Promise((resolve, reject) => {
      peque
        .api("shares/latest_numeration", {
          company: window.currentCompany.id,
          share_class: this.getInt("share-class"),
        })
        .then((response) => {
          this.latestNumeration = response.result;
          resolve(response.result);
        });
    });
  }

  mutateReactTransactions() {
    if (!!window.reactTransactionsMutate) {
      window.reactTransactionsMutate();
      this.hide();

      if (!!peque.transactionSelectionModal) {
        peque.transactionSelectionModal.hide();
      }
    } else {
      location.reload();
    }
  }

  openReactBulkModal(transactionType) {
    if (!window["reactShowAddBulkTransactionModal"] || !transactionType) {
      console.error("Bulk modal could not be shown");
    } else {
      this.hide();
      window["reactShowAddBulkTransactionModal"](Number(transactionType));
    }
  }
}

window.TransactionModal = TransactionModal;
